// Mock appointment data — replace with real backend/API calls
export const mockAppointments = [
  {
    id: "APT001",
    name: "Ananya Sharma",
    phone: "+91 98765 43210",
    service: "Dental Implants",
    date: "April 10, 2026",
    slots: ["10:00 AM", "11:00 AM", "2:00 PM"],
    confirmedSlot: null,
    message: "Had an extraction 2 months ago, need implant consultation.",
    status: "pending",
    createdAt: "2026-04-05T09:12:00",
  },
  {
    id: "APT002",
    name: "Rajesh Kumar",
    phone: "+91 87654 32109",
    service: "Root Canal Treatment",
    date: "April 11, 2026",
    slots: ["9:00 AM", "9:30 AM"],
    confirmedSlot: "9:00 AM",
    message: "",
    status: "confirmed",
    createdAt: "2026-04-05T10:30:00",
  },
  {
    id: "APT003",
    name: "Preethi Menon",
    phone: "+91 76543 21098",
    service: "Cosmetic Dentistry",
    date: "April 12, 2026",
    slots: ["3:00 PM", "4:00 PM", "5:00 PM"],
    confirmedSlot: null,
    message: "Interested in teeth whitening and veneers.",
    status: "pending",
    createdAt: "2026-04-05T11:00:00",
  },
  {
    id: "APT004",
    name: "Suresh Babu",
    phone: "+91 65432 10987",
    service: "Teeth Cleaning",
    date: "April 08, 2026",
    slots: ["11:00 AM"],
    confirmedSlot: "11:00 AM",
    message: "",
    status: "confirmed",
    createdAt: "2026-04-04T08:45:00",
  },
  {
    id: "APT005",
    name: "Meena Reddy",
    phone: "+91 54321 09876",
    service: "Dental Braces",
    date: "April 09, 2026",
    slots: ["4:30 PM", "5:00 PM"],
    confirmedSlot: null,
    message: "",
    status: "cancelled",
    createdAt: "2026-04-04T14:20:00",
  },
  {
    id: "APT006",
    name: "Vikram Nair",
    phone: "+91 43210 98765",
    service: "Other",
    reason: "Jaw pain and swelling since 3 days",
    date: "April 10, 2026",
    slots: ["9:00 AM", "9:30 AM", "10:00 AM"],
    confirmedSlot: null,
    message: "Pain is getting worse.",
    status: "pending",
    createdAt: "2026-04-05T07:55:00",
  },
  {
    id: "APT007",
    name: "Divya Krishnamurthy",
    phone: "+91 32109 87654",
    service: "General Checkup",
    date: "April 14, 2026",
    slots: ["10:30 AM", "11:00 AM"],
    confirmedSlot: "10:30 AM",
    message: "Routine annual checkup.",
    status: "confirmed",
    createdAt: "2026-04-05T13:10:00",
  },
  {
    id: "APT008",
    name: "Arjun Patel",
    phone: "+91 21098 76543",
    service: "Oral Surgery",
    date: "April 15, 2026",
    slots: ["2:00 PM", "2:30 PM"],
    confirmedSlot: null,
    message: "Wisdom tooth causing severe pain.",
    status: "pending",
    createdAt: "2026-04-05T15:00:00",
  },
];

export const serviceColors = {
  "Dental Implants":      { bg: "#e8f4fd", color: "#1a6fa8" },
  "Root Canal Treatment": { bg: "#fef3e8", color: "#b86a0a" },
  "Cosmetic Dentistry":   { bg: "#fce8f5", color: "#9a1f7a" },
  "Teeth Cleaning":       { bg: "#e8f7f5", color: "#0a7c6e" },
  "Dental Braces":        { bg: "#ede8fd", color: "#5b3fa8" },
  "Oral Surgery":         { bg: "#fde8e8", color: "#a81a1a" },
  "General Checkup":      { bg: "#e8fde8", color: "#1a8a1a" },
  "Other":                { bg: "#f5f5f5", color: "#555555" },
};